import { Modal, Space, Typography, message } from 'antd'
import { useState } from 'react'

import { ERRORS_MESSAGE_MAPPER } from '../../constants/errors'
import { axiosInstance } from '../../hooks/useAxios'
import {
  clearMerchantScopedCache,
  notifyMerchantSwitched,
} from '../../utils/cache'
import { MerchantStatus } from '../../types/merchant'
import MerchantOptionSelect from './MerchantOptionSelect'
import MerchantStatusTags from './MerchantStatusTags'

interface Props {
  open: boolean
  onClose: () => void
  username: string
  currentMerchant?: string
  currentMerchantName?: string
  currentMerchantStatus?: MerchantStatus
  currentMerchantExpired?: boolean
}

// super admin สลับร้านหลังล็อกอินแล้ว — ข้อมูลร้านเดิมค้างอยู่ทั้งใน cache และ state
// หลายหน้า จึงโหลดหน้าใหม่ทั้งหมดแทนการไล่รีเฟรชทีละจุด
const MerchantSwitchModal = ({
  open,
  onClose,
  username,
  currentMerchant,
  currentMerchantName,
  currentMerchantStatus,
  currentMerchantExpired,
}: Props) => {
  const [merchant, setMerchant] = useState<string>('')
  const [isSaving, setIsSaving] = useState<boolean>(false)

  const handleSwitch = async () => {
    setIsSaving(true)
    try {
      await axiosInstance.put('/users/username/merchant', {
        username,
        merchant,
      })
      clearMerchantScopedCache()
      notifyMerchantSwitched()
      window.location.reload()
    } catch (e: any) {
      message.error(
        ERRORS_MESSAGE_MAPPER?.[e?.response?.data?.message ?? ''] ||
          'เปลี่ยนร้านไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
      )
      setIsSaving(false)
    }
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      afterClose={() => setMerchant('')}
      title="เปลี่ยนร้าน"
      okText="เปลี่ยนร้าน"
      cancelText="ยกเลิก"
      onOk={handleSwitch}
      confirmLoading={isSaving}
      okButtonProps={{ disabled: !merchant || merchant === currentMerchant }}
      destroyOnClose
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Typography.Text>
          ร้านปัจจุบัน: <b>{currentMerchantName || currentMerchant || '-'}</b>
          {currentMerchantName && currentMerchant
            ? ` (${currentMerchant})`
            : ''}{' '}
          {currentMerchant && (
            <MerchantStatusTags
              status={currentMerchantStatus}
              isExpired={currentMerchantExpired}
            />
          )}
        </Typography.Text>
        <MerchantOptionSelect value={merchant} onChange={setMerchant} />
      </Space>
    </Modal>
  )
}

export default MerchantSwitchModal
